/**
 * Singleton utility for Magento BASE_URL
 *
 * Caches the base URL from window.BASE_URL to prevent repeated
 * window access and ensure consistent behavior.
 */

let baseUrlCache: string | null = null
let cacheInitialized = false

/**
 * Get Magento BASE_URL (singleton pattern)
 *
 * @returns Base URL string or empty string if not available
 */
export function getBaseUrl(): string {
  if (cacheInitialized) {
    return baseUrlCache ?? ''
  }

  if (typeof window !== 'undefined') {
    baseUrlCache = (window as { BASE_URL?: string }).BASE_URL ?? ''
  } else {
    baseUrlCache = ''
  }

  cacheInitialized = true
  return baseUrlCache ?? ''
}
